<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 回答方法
      span.validation-label 必須

    .register-value.support-radios
      label.register-radio-label
        input#contact-method-0.register-radio-form(
          v-model="_value"
          name="contact-method"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="回答方法")
        span.register-radio-text システム上で回答

      label.register-radio-label(v-if="1 <= planType")
        input#contact-method-1.register-radio-form(v-model="_value" name="contact-method" type="radio" :value="1")
        span.register-radio-text メール回答を希望
      div(v-show="planType < 1")
        label#disable-method-1.register-radio-label
          span.register-radio-text.disable メール回答を希望
        b-popover(target="disable-method-1" triggers="hover" placement="top")
          template(v-slot:title) メール回答を希望
          span ※ ライトプラン以上で設定可能

      label.register-radio-label(v-if="1 <= planType")
        input#contact-method-2.register-radio-form(v-model="_value" name="contact-method" type="radio" :value="2")
        span.register-radio-text 電話回答を希望
      div(v-show="planType < 1")
        label#disable-method-2.register-radio-label
          span.register-radio-text.disable 電話回答を希望
        b-popover(target="disable-method-2" triggers="hover" placement="top")
          template(v-slot:title) 電話回答を希望
          span ※ ライトプラン以上で設定可能

    .error-messages(v-for="error in errors.collect('contact-method')")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { PlanType } from "@/commons/services/Plans";

/**
 * 入力要素コンポーネント
 *
 * - お問い合わせの回答方法の入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputSupportMethod extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string;

  @Prop({ required: true, type: Number })
  planType!: PlanType;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.support-radios {
  flex-wrap: wrap;
}
</style>
